// extracted by mini-css-extract-plugin
export default {"bigLogo":"home_bigLogo__jAt7J","collageImages":"home_collageImages__nr5Dl"};